/*
|--------------------------------------------------------------------------
| Views: Flipp
|--------------------------------------------------------------------------
*/
/**
 * Loads views.flipp.callbacks after view is rendered
 */
__gh__webApp.views.flipp = {

	"callbacks": function(){
		__gh__webApp.ads.flipp.loadWidgetElement();
	},
	
	"getSubView": function(bucket){		
		var getIP = __gh__webApp.utilities.fetch.json.get({
				"url":"apps/pbcs.dll/exec?name=clientip.php"
			}),
			ipDisabled = new RegExp(__gh__coreData["3rdPartyData"].ads.flipp.disableByIp),
			ipMatch = (ipDisabled.test(getIP.ip));

		return (ipMatch) ? false : bucket;
	}
};
